// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"286":"5dcb399c","313":"325739cd","342":"c8c38b6e","452":"4c71a737","611":"673a07a1","787":"6d41730f","979":"b1958d50"}[chunkId] + ".chunk.js";
};